import { useApi } from 'lib/contexts/ApplicationState';
import { Role } from 'lib/types';
import { AddCredit } from 'lib/types/credits';
import { PostingAccount } from 'lib/types/postingAccounts';
import { User } from 'lib/types/users';

export const useAddCredits = () => {
  const API = useApi();

  const formatCredits = (
    user: User, roles: Role[], isPrivate?: boolean,
  ) => roles.map((r) => (
    {
      roleId: r.id,
      userId: user.id,
      isPrivate,
    }
  )) as AddCredit[];

  const addCredits = async (
    postIds: number[], user: User, roles: Role[], isPrivate?: boolean,
  ): Promise<PostingAccount> => {
    const credits = formatCredits(user, roles, isPrivate);
    return API.createCredits({
      postIds,
      credits,
    });
  };

  return { addCredits };
};
